<sd-modal
  [brand]="brand"
  [type]="_type"
  [clickToClose]="clickToClose"
  [backdrop]="true"
  [modalCustomClass]="'c__modal-default ' + modalCustomClass"
  [(isOpened)]="isOpened"
  (isOpenedChange)="onOpenedChange()"
  [disabled]="disabled"
>
  @if (!hasHeader) {
    <ng-container sd-modal-header>
      @if (modalTitle) {
        <sd-title class="is-visually-hidden" [titleLevel]="modalTitleLevel">
          {{ modalTitle }}
        </sd-title>
      }
      <ng-container sd-modal-close>
        <button #closeModalButton
          sd-button
          [brand]="brand"
          icon="icon-cross"
          [isIcon]="true"
          [isSmall]="true"
          class="is-absolute"
          (click)="close()"
          id="modalCloseButton"
          [ngClass]="{'is-show-text' : showCloseText}"
        >
          <span [ngClass]="{'is-visually-hidden' : !showCloseText}">{{ "actions.close" | translate }} {{ !showCloseText ? modalTitle : '' }}</span>
        </button>
      </ng-container>
    </ng-container>
  }

  @if (hasHeader) {
    <header sd-modal-header>
      @if (modalTitle && !titleHidden) {
        <sd-title [customClass]="isMobile$ ? 'brand--h5' : 'brand--h4'" [titleLevel]="modalTitleLevel">
          {{ modalTitle }}
        </sd-title>
      }
      <ng-container sd-modal-close>
        <button #closeModalButton
          sd-button
          [brand]="brand"
          icon="icon-cross"
          [isIcon]="true"
          [isSmall]="true"
          (click)="close()"
          id="modalCloseButton"
          [ngClass]="{'is-show-text' : showCloseText}"
        >
          <span [ngClass]="{'is-visually-hidden' : !showCloseText}">{{ "actions.close" | translate }} {{ !showCloseText ? modalTitle : '' }}</span>
        </button>
      </ng-container>
    </header>
  }

  <div class="c__modal-wrapper {{noPadding ? 'has-no-padding' : ''}}" sd-modal-body>
    <ng-content />
  </div>
</sd-modal>
